import React, { useEffect } from "react";
import { Navigate } from "react-router-dom";

import { authProvider } from "../app/auth";
import HttpService from "../app/http";
import Contexts from "../contexts/index";
import { initialState, IUser } from "../contexts/types";
import useAppLocalStorage from "../hooks/useAppLocalStorage";

// List your permission as key:value pairs
export const PermissionsMapper = {};

export const can = (permissions: string[], permission: string): boolean => {
  if (permissions.includes(permission)) return true;
  else return false;
};

const AuthProvider = ({ children }: { children: React.ReactNode }) => {
  const localStorage = useAppLocalStorage();

  const [user, setUser] = React.useState<IUser>(initialState);
  const [customer_identification, setCustomer_identification] =
    React.useState<string>("");

  useEffect(() => {
    let item = false;

    const sessionData: any = localStorage.getItem(
      `${import.meta.env.VITE_STORAGE_PREFIX}_service`
    );

    if (sessionData) {
      item = true;

      const { exp, rememberMe, ...rest } = JSON.parse(sessionData);

      if (item && new Date(exp) >= new Date()) {
        return authProvider.login(() => {
          setUser({ ...rest, isAuthenticated: true });
          setCustomer_identification(rest.userIdentification);
        });
      } else {
        return () => {
          return <Navigate to={"/logout"} />;
        };
      }
    }

    return () => {
      item = false;
    };
  }, [localStorage]);

  const login = (data: any) => {
    if (data.rememberMe) {
      const exp = new Date();
      exp.setDate(exp.getDate() + 7);

      localStorage.setItem(
        `${import.meta.env.VITE_STORAGE_PREFIX}_service`,
        JSON.stringify({ ...data, exp })
      );
    } else {
      const exp = new Date();
      exp.setDate(exp.getDate() + 1);

      localStorage.setItem(
        `${import.meta.env.VITE_STORAGE_PREFIX}_service`,
        JSON.stringify({ ...data, exp })
      );
    }

    HttpService.setToken(data);

    return authProvider.login(() => {
      setUser({ ...data, isAuthenticated: true });
      setCustomer_identification(data.userIdentification);
    });
  };

  const logout = () => {
    return authProvider.logout(() => {
      setUser(initialState);
    });
  };

  const value = { user, customer_identification, setUser, login, logout };

  return (
    <Contexts.AuthContext.Provider value={value}>
      {children}
    </Contexts.AuthContext.Provider>
  );
};

export default AuthProvider;
